export default __webpack_public_path__ + "db944cab44e2016c2446ea332b2f7658.svg";